/**
 * The browse canvas's `pastTheEnd` statement (#6922) — what the results pane
 * says when the served page stands past the search's last page.
 *
 * ONE component for both panes (the desktop side panel and the mobile drawer),
 * so the two cannot word it differently — the same reason both mount one
 * `ResultsCount`. It is a statement and nothing else: the way back to page 1
 * is the pager's (`ListingsPager`), which owns the routes. `data-slot` is its
 * identity for the browser suite, so a spec names it without naming copy or
 * classes.
 */
import { useTranslations } from '@/shared/i18n/useTranslations';
import { cn } from '@letsgethome/ui/lib/utils';

export function PastTheEndStatement({ className }: { className?: string }) {
  const t = useTranslations('listings.browse');
  return (
    <div
      data-slot="listings-past-the-end"
      className={cn(
        'flex items-center justify-center text-center text-muted-foreground',
        className
      )}
    >
      <p>{t('pastTheEnd')}</p>
    </div>
  );
}
